import { DiagnosticVM, DiagnosticsList, StudentForDiagnostic } from '../../../Elearning-Models';
import { DiagnosticsVM } from 'src/app/Elearning-Models';

export class DiagnosticsDataServiceMockValues {

  public diagnosticsData: DiagnosticsVM[] = [
    {
      "ClassID": 1232314,
      "ClassName": "Algebra I Sec 12",
      "Diagnostics": [
        {
          "DiagExamSkippedCount": 1,
          "DiagLessonsSkippedCount": 2,
          "DimDistrictExamID": 1111,
          "IsELearning":true,
          "DiagnosticExamID": 1,
          "LessonID": 234234,
          "LessonName": "Algebra Fall  Diagnostic",
          "AssignmentID": 1234345,
          "DiagInProgress": 1,
          "LessonsComplete": 3,
          "LessonsTotal": 12,
          "StudentsNeedAttentionCount": 6,
          StudentsExamInProgress: [],
          StudentsNotStartedExam: [{StudentID: 111, StudentName: "Kyle Roberts", AttemptID: -1, Grade: ""}],
          "StudentsUnassigned": [
            {
              "StudentID": 111,
              "StudentName": "John",
              Grade:"50"
            },
            {
              "StudentID": 112,
              "StudentName": "Bill",
              Grade:"50"
            }
          ],
          "StudentsNeedDiagGraded": [
            {
              "StudentID": 222,
              "StudentName": "Janet",
              "AttemptID" : 1,
              Grade:"50"
            },
            {
              "StudentID": 223,
              "StudentName": "Sally",
              "AttemptID" : 2,
              Grade:"50"
            }
          ],
          "StudentsawaitingILP": [
            {
              "StudentID": 333,
              "StudentName": "Kim",
              Grade:"50"
            },
            {
              "StudentID": 334,
              "StudentName": "Andrew",
              Grade:"50"
            }
          ],
          "StudentsWithLessons": [
            {
              "StudentID": 334,
              "StudentName": "Andrew",
              "LessonsAssigned": 3,
              "LessonsCompleted": 1,
              "LastSubmittedDate": "2020-10-01",
              "NeedsAttentionCount": 2,
              Grade: "25",
              AverageILPGrade: "34.5",
              "Assignments": [
                {
                  "LessonID": 21342314,
                  "LessonName": "Multiplying Fractions",
                  "AssignmentID": 21341234,
                  "AttemptID": 2344231,
                  "Grade": "88",
                  "GradeReleased": true,
                  SentBack: false,
                  SubmittedAsComplete: true,
                  SubmitDate: "02/03/44"
                },
                {
                  "LessonID": 21342314,
                  "LessonName": "Dividing Fractions",
                  "AssignmentID": 53423542345,
                  "AttemptID": 3342355,
                  "Grade": "80",
                  "GradeReleased": false,
                  SentBack: false,
                  SubmittedAsComplete: true,
                  SubmitDate: ""
                }
              ]
            }
          ],
          StudentsLessonSkipList: [{StudentName : "Kyle Roberts", StudentID : 123, Grade : "50"}],
          StudentsYieldedNoILP: []
        },
        {
          "DiagExamSkippedCount": 1,
          "DiagLessonsSkippedCount": 2,
          "DimDistrictExamID": 1112,
          "IsELearning": true,
          "DiagnosticExamID": 2,
          "LessonID": 234235,
          "LessonName": "Mathematics Diagnostic",
          "AssignmentID": 1234346,
          "DiagInProgress": 3,
          "LessonsComplete": 5,
          "LessonsTotal": 12,
          "StudentsNeedAttentionCount": 5,
          StudentsExamInProgress: [],
          StudentsNotStartedExam: [{StudentID: 111, StudentName: "Kyle Roberts", AttemptID: -1, Grade: ""}],
          "StudentsUnassigned": [
            {
              "StudentID": 111,
              "StudentName": "John",
              Grade:"50"
            },
            {
              "StudentID": 112,
              "StudentName": "Bill",
              Grade:"50"
            }
          ],
          StudentsLessonSkipList: [{StudentName : "Kyle Roberts", StudentID : 123, Grade : "50"}],
          StudentsYieldedNoILP: [],
          "StudentsNeedDiagGraded": [
            {
              "StudentID": 222,
              "StudentName": "Janet",
              "AttemptID" : 1,
              Grade:"50"
            },
            {
              "StudentID": 223,
              "StudentName": "Sally",
              "AttemptID": 2,
              Grade:"50"
            }
          ],
          "StudentsawaitingILP": [
            {
              "StudentID": 333,
              "StudentName": "Kim",
              Grade:"50"
            },
            {
              "StudentID": 334,
              "StudentName": "Andrew",
              Grade:"50"
            }
          ],
          "StudentsWithLessons": [
            {
              "StudentID": 334,
              "StudentName": "Andrew",
              "LessonsAssigned": 3,
              "LessonsCompleted": 1,
              "LastSubmittedDate": "2020-10-01",
              "NeedsAttentionCount": 2,
              Grade: "25",
              AverageILPGrade: "34.5",
              "Assignments": [
                {
                  "LessonID": 21342314,
                  "LessonName": "Multiplying Fractions",
                  "AssignmentID": 21341234,
                  "AttemptID": 2344231,
                  "Grade": "88",
                  "GradeReleased": true,
                  SentBack: false,
                  SubmittedAsComplete: true,
                  SubmitDate: "02/03/44"
                },
                {
                  "LessonID": 21342314,
                  "LessonName": "Dividing Fractions",
                  "AssignmentID": 53423542345,
                  "AttemptID": 3342355,
                  "Grade": "80",
                  "GradeReleased": false,
                  SentBack: false,
                  SubmittedAsComplete: true,
                  SubmitDate: ""
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "ClassID": 1232314,
      "ClassName": "Chemistry Sec 9",
      "Diagnostics": []
    }
  ]

  public diagnosticData: DiagnosticVM = {
   "IsELearning":true,
   "DimDistrictExamID":86142,
   "LessonID":-1,
   "DiagnosticExamID":2154,
   "LessonName":"CC Algebra Diagnostic",
   "AssignmentID":1502232,
   "DiagInProgress":5,
   "LessonsComplete":13,
   "LessonsTotal":121,
   "StudentsNeedAttentionCount":3,
   "StudentsYieldedNoILP":[
      {
         "StudentID":894089,
         "StudentName":"Student, AceTheDiagExamAndGetNoILP",
         "Grade":""
      }
   ],
   "StudentsLessonSkipList":[
      {
         "StudentID":894078,
         "StudentName":"NotGraded, SubmittedExamInClassB",
         "Grade":""
      },
      {
         "StudentID":894088,
         "StudentName":"Student, SkipMeFromDiagLessons",
         "Grade":""
      }
   ],
   "StudentsUnassigned":[
      
   ],
   "StudentsNeedDiagGraded":[
      {
         "StudentID":894080,
         "StudentName":"Student, NotAssignedExamAtAll",
         "AttemptID":1290667,
         "Grade":""
      }
   ],
   "StudentsNotStartedExam":[
      {
         "StudentID":894081,
         "StudentName":"Student, NotAssignedExamAtAll",
         "AttemptID":-1,
         "Grade":""
      },
      {
         "StudentID":894082,
         "StudentName":"Student, NotAssignedExamAtAll",
         "AttemptID":-1,
         "Grade":""
      },
      {
         "StudentID":894084,
         "StudentName":"Student, NotAssignedExamAtAll",
         "AttemptID":-1,
         "Grade":""
      },
      {
         "StudentID":894085,
         "StudentName":"Student, NotAssignedExamAtAll",
         "AttemptID":-1,
         "Grade":""
      }
   ],
   "StudentsExamInProgress":[
      {
         "StudentID":894083,
         "StudentName":"Student, NotAssignedExamAtAll",
         "AttemptID":1290668,
         "Grade":""
      }
   ],
   "StudentsawaitingILP":[
      {
         "StudentID":894077,
         "StudentName":"Graded, SubmittedExamInClassA",
         "Grade":"20.83"
      }
   ],
   "StudentsWithLessons":[
      {
         "StudentID":894079,
         "StudentName":"Graded, SubmittedExamInClassB",
         "LessonsAssigned":28,
         "LessonsCompleted":0,
         "LastSubmittedDate":null,
         "NeedsAttentionCount":0,
         "Grade":"29.17",
         "AverageILPGrade":"",
         "Assignments":[
            {
               "LessonID":128073,
               "LessonName":"Steps for Solving Algebraic Problems",
               "AssignmentID":1504696,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128074,
               "LessonName":"Solving One Variable Equations and Inequalities",
               "AssignmentID":1504697,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":97253,
               "LessonName":"Solving Systems of Equations by Graphing",
               "AssignmentID":1504700,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128078,
               "LessonName":"Solving Systems of Equations by Substitution",
               "AssignmentID":1504701,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128079,
               "LessonName":"Solving Systems of Equations by Elimination",
               "AssignmentID":1504702,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128145,
               "LessonName":"Graphing Linear Inequalities",
               "AssignmentID":1504703,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":108081,
               "LessonName":"Systems of Linear Inequalities",
               "AssignmentID":1504704,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128082,
               "LessonName":"Understanding Functions",
               "AssignmentID":1504705,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128083,
               "LessonName":"Evaluating Functions",
               "AssignmentID":1504706,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":102833,
               "LessonName":"Recognizing Sequences as Functions",
               "AssignmentID":1504707,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":108116,
               "LessonName":"Finding Appropriate Domains",
               "AssignmentID":1504709,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128085,
               "LessonName":"Average Rate of Change",
               "AssignmentID":1504710,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":111697,
               "LessonName":"Building Functions",
               "AssignmentID":1504711,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128088,
               "LessonName":"Identifying Linear and Exponential Functional Relationships",
               "AssignmentID":1504712,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":92355,
               "LessonName":"Unit 2 Assessment: Linear and Exponential Relationships",
               "AssignmentID":1504713,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128129,
               "LessonName":"Adding and Subtracting Polynomials",
               "AssignmentID":1504719,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128130,
               "LessonName":"Multiplying Polynomials",
               "AssignmentID":1504720,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128136,
               "LessonName":"Creating Quadratic Equations to Solve Problems",
               "AssignmentID":1504723,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128139,
               "LessonName":"Rearrange Formulas and Equations Involving Squares",
               "AssignmentID":1504724,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128140,
               "LessonName":"Completing the Square to Solve Quadratic Equations",
               "AssignmentID":1504725,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128142,
               "LessonName":"Four Methods to Solve Quadratic Equations",
               "AssignmentID":1504726,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":108638,
               "LessonName":"Roots of Quadratic Equations (Graphically)",
               "AssignmentID":1504727,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128144,
               "LessonName":"Solve Problems Involving Quadratic Equations",
               "AssignmentID":1504728,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":102831,
               "LessonName":"Unit 4 Test - Quadratic Expressions and Equations",
               "AssignmentID":1504729,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":97319,
               "LessonName":"Domain and Range",
               "AssignmentID":1504731,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":108117,
               "LessonName":"Average Rate of Change - Quadratic Functions",
               "AssignmentID":1504732,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128160,
               "LessonName":"Creating Functions ",
               "AssignmentID":1504733,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":93018,
               "LessonName":"Unit 5 Assessment: Quadratic Functions and Modeling ",
               "AssignmentID":1504734,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            }
         ]
      },
      {
         "StudentID":894086,
         "StudentName":"Student, AssignedExamNotOpened",
         "LessonsAssigned":13,
         "LessonsCompleted":11,
         "LastSubmittedDate":"4/5/2021 1:57:45 PM",
         "NeedsAttentionCount":11,
         "Grade":"0",
         "AverageILPGrade":"33",
         "Assignments":[
            {
               "LessonID":97233,
               "LessonName":"Creating Linear and Exponential Models to Solve Problems",
               "AssignmentID":1504694,
               "AttemptID":1290654,
               "Grade":"33",
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":true,
               "SubmitDate":"04/05/2021 01:12 PM"
            },
            {
               "LessonID":108085,
               "LessonName":"Solving Formulas and Equations for a Specific Variable",
               "AssignmentID":1504695,
               "AttemptID":1290670,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":true,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128073,
               "LessonName":"Steps for Solving Algebraic Problems",
               "AssignmentID":1504696,
               "AttemptID":1290669,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":true,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128074,
               "LessonName":"Solving One Variable Equations and Inequalities",
               "AssignmentID":1504697,
               "AttemptID":1290657,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":true,
               "SubmitDate":"04/05/2021 01:39 PM"
            },
            {
               "LessonID":90217,
               "LessonName":"Unit 1: Relationships between Quantities and Reasoning with Equations",
               "AssignmentID":1504698,
               "AttemptID":1290658,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":true,
               "SubmitDate":"04/05/2021 01:39 PM"
            },
            {
               "LessonID":128075,
               "LessonName":"Rational Exponents and Radicals",
               "AssignmentID":1504699,
               "AttemptID":1290659,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":true,
               "SubmitDate":"04/05/2021 01:45 PM"
            },
            {
               "LessonID":97253,
               "LessonName":"Solving Systems of Equations by Graphing",
               "AssignmentID":1504700,
               "AttemptID":1290660,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":true,
               "SubmitDate":"04/05/2021 01:46 PM"
            },
            {
               "LessonID":128145,
               "LessonName":"Graphing Linear Inequalities",
               "AssignmentID":1504703,
               "AttemptID":1290662,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":true,
               "SubmitDate":"04/05/2021 01:52 PM"
            },
            {
               "LessonID":108081,
               "LessonName":"Systems of Linear Inequalities",
               "AssignmentID":1504704,
               "AttemptID":1290661,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":true,
               "SubmitDate":"04/05/2021 01:46 PM"
            },
            {
               "LessonID":128082,
               "LessonName":"Understanding Functions",
               "AssignmentID":1504705,
               "AttemptID":1290664,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":true,
               "SubmitDate":"04/05/2021 01:56 PM"
            },
            {
               "LessonID":128083,
               "LessonName":"Evaluating Functions",
               "AssignmentID":1504706,
               "AttemptID":1290663,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":true,
               "SubmitDate":"04/05/2021 01:52 PM"
            },
            {
               "LessonID":128085,
               "LessonName":"Average Rate of Change",
               "AssignmentID":1504710,
               "AttemptID":1290665,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":true,
               "SubmitDate":"04/05/2021 01:57 PM"
            },
            {
               "LessonID":128160,
               "LessonName":"Creating Functions ",
               "AssignmentID":1504733,
               "AttemptID":1290666,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":true,
               "SubmitDate":""
            }
         ]
      },
      {
         "StudentID":894080,
         "StudentName":"Student, NotAssignedExamAtAll",
         "LessonsAssigned":40,
         "LessonsCompleted":0,
         "LastSubmittedDate":null,
         "NeedsAttentionCount":0,
         "Grade":"0",
         "AverageILPGrade":"",
         "Assignments":[
            {
               "LessonID":97233,
               "LessonName":"Creating Linear and Exponential Models to Solve Problems",
               "AssignmentID":1504776,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":108085,
               "LessonName":"Solving Formulas and Equations for a Specific Variable",
               "AssignmentID":1504777,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128073,
               "LessonName":"Steps for Solving Algebraic Problems",
               "AssignmentID":1504778,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128074,
               "LessonName":"Solving One Variable Equations and Inequalities",
               "AssignmentID":1504779,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128075,
               "LessonName":"Rational Exponents and Radicals",
               "AssignmentID":1504781,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":97253,
               "LessonName":"Solving Systems of Equations by Graphing",
               "AssignmentID":1504782,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128078,
               "LessonName":"Solving Systems of Equations by Substitution",
               "AssignmentID":1504783,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128079,
               "LessonName":"Solving Systems of Equations by Elimination",
               "AssignmentID":1504784,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128145,
               "LessonName":"Graphing Linear Inequalities",
               "AssignmentID":1504785,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":108081,
               "LessonName":"Systems of Linear Inequalities",
               "AssignmentID":1504786,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128082,
               "LessonName":"Understanding Functions",
               "AssignmentID":1504787,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128083,
               "LessonName":"Evaluating Functions",
               "AssignmentID":1504788,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":102833,
               "LessonName":"Recognizing Sequences as Functions",
               "AssignmentID":1504789,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128084,
               "LessonName":"Key Features of Linear and Exponential Functions",
               "AssignmentID":1504790,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":108116,
               "LessonName":"Finding Appropriate Domains",
               "AssignmentID":1504791,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128085,
               "LessonName":"Average Rate of Change",
               "AssignmentID":1504792,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":111697,
               "LessonName":"Building Functions",
               "AssignmentID":1504793,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128088,
               "LessonName":"Identifying Linear and Exponential Functional Relationships",
               "AssignmentID":1504794,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":92355,
               "LessonName":"Unit 2 Assessment: Linear and Exponential Relationships",
               "AssignmentID":1504795,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":97287,
               "LessonName":"Dot Plots, Histograms, and Box Plots",
               "AssignmentID":1504796,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":97291,
               "LessonName":"Scatter Plots and Lines of Best Fit",
               "AssignmentID":1504797,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":108150,
               "LessonName":"Using the Line of Best Fit",
               "AssignmentID":1504798,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":99880,
               "LessonName":"Bivariate Statistics and Linear Regression",
               "AssignmentID":1504799,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":91839,
               "LessonName":"Unit 3: Descriptive Statistics",
               "AssignmentID":1504800,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128129,
               "LessonName":"Adding and Subtracting Polynomials",
               "AssignmentID":1504801,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128130,
               "LessonName":"Multiplying Polynomials",
               "AssignmentID":1504802,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128134,
               "LessonName":"Factor to Find the Zeros of a Quadratic Function",
               "AssignmentID":1504803,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128135,
               "LessonName":"Complete the Square to Find Max/Min of Quadratic Function",
               "AssignmentID":1504804,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128136,
               "LessonName":"Creating Quadratic Equations to Solve Problems",
               "AssignmentID":1504805,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128139,
               "LessonName":"Rearrange Formulas and Equations Involving Squares",
               "AssignmentID":1504806,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128140,
               "LessonName":"Completing the Square to Solve Quadratic Equations",
               "AssignmentID":1504807,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128142,
               "LessonName":"Four Methods to Solve Quadratic Equations",
               "AssignmentID":1504808,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":108638,
               "LessonName":"Roots of Quadratic Equations (Graphically)",
               "AssignmentID":1504809,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128144,
               "LessonName":"Solve Problems Involving Quadratic Equations",
               "AssignmentID":1504810,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":102831,
               "LessonName":"Unit 4 Test - Quadratic Expressions and Equations",
               "AssignmentID":1504811,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128156,
               "LessonName":"Key Characteristics of the Graphs of Quadratic Functions",
               "AssignmentID":1504812,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":97319,
               "LessonName":"Domain and Range",
               "AssignmentID":1504813,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":108117,
               "LessonName":"Average Rate of Change - Quadratic Functions",
               "AssignmentID":1504814,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128160,
               "LessonName":"Creating Functions ",
               "AssignmentID":1504815,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":93018,
               "LessonName":"Unit 5 Assessment: Quadratic Functions and Modeling ",
               "AssignmentID":1504816,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            }
         ]
      },
      {
         "StudentID":894090,
         "StudentName":"Student, HalfCorrectOnExam",
         "LessonsAssigned":1,
         "LessonsCompleted":1,
         "LastSubmittedDate":"3/23/2021 11:23:37 AM",
         "NeedsAttentionCount":0,
         "Grade":"50",
         "AverageILPGrade":"0",
         "Assignments":[
            {
               "LessonID":97233,
               "LessonName":"Creating Linear and Exponential Models to Solve Problems",
               "AssignmentID":1504694,
               "AttemptID":1290652,
               "Grade":"0",
               "GradeReleased":true,
               "SentBack":false,
               "SubmittedAsComplete":true,
               "SubmitDate":"03/23/2021 11:23 AM"
            }
         ]
      },
      {
         "StudentID":894091,
         "StudentName":"Frowny Face, UnAssignAllMyLessons",
         "LessonsAssigned":39,
         "LessonsCompleted":0,
         "LastSubmittedDate":null,
         "NeedsAttentionCount":0,
         "Grade":"0",
         "AverageILPGrade":"",
         "Assignments":[
            {
               "LessonID":108085,
               "LessonName":"Solving Formulas and Equations for a Specific Variable",
               "AssignmentID":1504736,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128073,
               "LessonName":"Steps for Solving Algebraic Problems",
               "AssignmentID":1504737,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128074,
               "LessonName":"Solving One Variable Equations and Inequalities",
               "AssignmentID":1504738,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128075,
               "LessonName":"Rational Exponents and Radicals",
               "AssignmentID":1504740,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":97253,
               "LessonName":"Solving Systems of Equations by Graphing",
               "AssignmentID":1504741,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128078,
               "LessonName":"Solving Systems of Equations by Substitution",
               "AssignmentID":1504742,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128079,
               "LessonName":"Solving Systems of Equations by Elimination",
               "AssignmentID":1504743,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128145,
               "LessonName":"Graphing Linear Inequalities",
               "AssignmentID":1504744,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":108081,
               "LessonName":"Systems of Linear Inequalities",
               "AssignmentID":1504745,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128082,
               "LessonName":"Understanding Functions",
               "AssignmentID":1504746,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128083,
               "LessonName":"Evaluating Functions",
               "AssignmentID":1504747,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":102833,
               "LessonName":"Recognizing Sequences as Functions",
               "AssignmentID":1504748,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128084,
               "LessonName":"Key Features of Linear and Exponential Functions",
               "AssignmentID":1504749,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":108116,
               "LessonName":"Finding Appropriate Domains",
               "AssignmentID":1504750,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128085,
               "LessonName":"Average Rate of Change",
               "AssignmentID":1504751,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":111697,
               "LessonName":"Building Functions",
               "AssignmentID":1504752,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128088,
               "LessonName":"Identifying Linear and Exponential Functional Relationships",
               "AssignmentID":1504753,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":92355,
               "LessonName":"Unit 2 Assessment: Linear and Exponential Relationships",
               "AssignmentID":1504754,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":97287,
               "LessonName":"Dot Plots, Histograms, and Box Plots",
               "AssignmentID":1504755,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":97291,
               "LessonName":"Scatter Plots and Lines of Best Fit",
               "AssignmentID":1504756,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":108150,
               "LessonName":"Using the Line of Best Fit",
               "AssignmentID":1504757,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":99880,
               "LessonName":"Bivariate Statistics and Linear Regression",
               "AssignmentID":1504758,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":91839,
               "LessonName":"Unit 3: Descriptive Statistics",
               "AssignmentID":1504759,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128129,
               "LessonName":"Adding and Subtracting Polynomials",
               "AssignmentID":1504760,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128130,
               "LessonName":"Multiplying Polynomials",
               "AssignmentID":1504761,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128134,
               "LessonName":"Factor to Find the Zeros of a Quadratic Function",
               "AssignmentID":1504762,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128135,
               "LessonName":"Complete the Square to Find Max/Min of Quadratic Function",
               "AssignmentID":1504763,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128136,
               "LessonName":"Creating Quadratic Equations to Solve Problems",
               "AssignmentID":1504764,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128139,
               "LessonName":"Rearrange Formulas and Equations Involving Squares",
               "AssignmentID":1504765,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128140,
               "LessonName":"Completing the Square to Solve Quadratic Equations",
               "AssignmentID":1504766,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128142,
               "LessonName":"Four Methods to Solve Quadratic Equations",
               "AssignmentID":1504767,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":108638,
               "LessonName":"Roots of Quadratic Equations (Graphically)",
               "AssignmentID":1504768,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128144,
               "LessonName":"Solve Problems Involving Quadratic Equations",
               "AssignmentID":1504769,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":102831,
               "LessonName":"Unit 4 Test - Quadratic Expressions and Equations",
               "AssignmentID":1504770,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128156,
               "LessonName":"Key Characteristics of the Graphs of Quadratic Functions",
               "AssignmentID":1504771,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":97319,
               "LessonName":"Domain and Range",
               "AssignmentID":1504772,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":108117,
               "LessonName":"Average Rate of Change - Quadratic Functions",
               "AssignmentID":1504773,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":128160,
               "LessonName":"Creating Functions ",
               "AssignmentID":1504774,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            },
            {
               "LessonID":93018,
               "LessonName":"Unit 5 Assessment: Quadratic Functions and Modeling ",
               "AssignmentID":1504775,
               "AttemptID":-1,
               "Grade":null,
               "GradeReleased":false,
               "SentBack":false,
               "SubmittedAsComplete":false,
               "SubmitDate":""
            }
         ]
      }
   ],
   "DiagExamSkippedCount":1,
   "DiagLessonsSkippedCount":2,
}

  public diagnosticsList: DiagnosticsList[] =[
    {
      "ExamDesc": "Algebra Fall  Diagnostic",
      "DimDistrictExamID": 1234345
    },
    {
      "ExamDesc": "Mathematics Diagnostic",
      "DimDistrictExamID": 1234346
    }
  ]

  public skippedStudentsList: StudentForDiagnostic[] = [
    {
      "StudentID": 123,
      "StudentName": "David",
      Grade:"50"
    },
    {
      "StudentID": 234,
      "StudentName": "Glenn",
      Grade:"50"
    }
  ]

  public skippedLessonsStudentsList: StudentForDiagnostic[] = [
    {
      "StudentID": 234,
      "StudentName": "Justin",
      Grade:"50"
    },
    {
      "StudentID": 235,
      "StudentName": "Zach",
      Grade:"50"
    }
  ]
}
